const Constantes = {
    RUTA_API: "https://back.yourny.es:5000"
};

module.exports = Constantes;